<template>
    <v-col>
        <div class="wrapper">
            <div class="wrap-filters primary no-add-btn">
                <v-row align="center">
                    <v-col cols="12" md="8" sm="5">
                        <h1>{{ $t("tours.tracking_tours") }}</h1>
                    </v-col>
                    <v-col
                        class="text-center text-sm-right"
                        cols="12"
                        md="4"
                        sm="7"
                    >
                        <v-btn
                            text
                            dark
                            @click="reset"
                        >
                            {{ $t("global.reinitialize") }}
                        </v-btn>
                        <v-btn
                            elevation="0"
                            @click="filterTours"
                        >
                            {{ $t("global.search") }}
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="3">
                        <v-menu
                            v-model="menu_date_picker"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            min-width="auto"
                            offset-y
                            transition="scale-transition"
                        >
                            <template #activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateFormatted"
                                    :label="$t('global.date')"
                                    append-icon="mdi-calendar-range"
                                    dark
                                    dense
                                    hide-details="auto"
                                    outlined
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filters.expected_date"
                                :first-day-of-week="1"
                                locale="fr-FR"
                                range
                            >
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-select
                            v-model="filters.driver_id"
                            :item-text="
                                (item) => `${item.firstname} ${item.lastname}`
                            "
                            :items="drivers"
                            :label="driverLabel"
                            dark
                            dense
                            hide-details="auto"
                            item-value="id"
                            outlined
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-select
                            v-model="filters.tour_state_id"
                            :item-text="
                                (item) => $t('tour_states.' + item.code)
                            "
                            :items="tour_states"
                            :label="$t('tours.tour_status')"
                            dark
                            dense
                            hide-details="auto"
                            item-value="id"
                            outlined
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-select
                            v-model="filters.loading_state_id"
                            :item-text="
                                (item) => $t('loading_states.' + item.code)
                            "
                            :items="loading_states"
                            :label="$t('tours.status_loading')"
                            dark
                            dense
                            hide-details="auto"
                            item-value="id"
                            outlined
                        ></v-select>
                    </v-col>
                    <!--v-col cols="12" sm="3">
                        <v-select
                            v-model="filters.site_id"
                            :items="sites"
                            :label="$tc('tours.sites', 1)"
                            dark
                            dense
                            hide-details="auto"
                            item-text="label"
                            item-value="id"
                            outlined
                        ></v-select>
                    </v-col-->
                </v-row>
            </div>

            <div class="wrap-datables no-add-btn">
                <v-row>
                    <v-col cols="12" md="6" sm="12">
                        <v-text-field
                            v-model="search"
                            :label="$t('global.search')"
                            append-icon="mdi-magnify"
                            dense
                            hide-details="auto"
                            light
                            outlined
                            single-line
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            v-if="filters.per_page"
                            :footer-props="{
                                'items-per-page-options': [
                                    25, 50, 100, 500, -1,
                                ],
                            }"
                            :headers="headers"
                            :items="tours"
                            :items-per-page.sync="filters.per_page"
                            :loading="loading"
                            :page.sync="filters.page"
                            :search="search"
                            :server-items-length="totalTours"
                            @update:items-per-page="perPageChanged"
                            @update:page="pageChanged"
                        >
                            <template #[`item.expected_date`]="{ item }">
                                {{ item.expected_date.toDateTime() }}
                            </template>

                            <template #[`item.label`]="{ item }">
                                {{ item.designation_without_date }}
                            </template>

                            <template #[`item.driver`]="{ item }">
                                {{ item.driver }}
                            </template>

                            <template #[`item.loading`]="{ item }">
                                <v-tooltip top>
                                    <template #activator="{ on, attrs }">
                                        <v-icon
                                            :class="
                                                getLoading(
                                                    item.loading_state.code
                                                )
                                            "
                                            class="icon-load"
                                            size="24"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            mdi-{{
                                                getLoadingIcon(
                                                    item.loading_state.code
                                                )
                                            }}
                                        </v-icon>
                                    </template>
                                    <span>
                                        <span class="font-weight-bold">
                                            {{
                                                $t(
                                                    `loading_states.${item.loading_state.code}`
                                                )
                                            }}
                                        </span>
                                        <br/>
                                        {{ getTourTooltipDetail(item) }}
                                    </span>
                                </v-tooltip>
                            </template>

                            <template #[`item.tour_state`]="{ item }">
                                <v-tooltip top>
                                    <template #activator="{ on, attrs }">
                                        <v-icon
                                            :class="
                                                getTourStatus(
                                                    item.tour_state.code
                                                )
                                            "
                                            class="icon-tour-status"
                                            size="20"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            mdi-{{
                                                getTourStatusIcon(
                                                    item.tour_state.code
                                                )
                                            }}
                                        </v-icon>
                                    </template>
                                    <span class="font-weight-bold">{{
                                            $t(
                                                `tour_states.${item.tour_state.code}`
                                            )
                                        }}</span>
                                </v-tooltip>
                            </template>

                            <template #[`item.actions`]="{ item }">
                                <v-btn
                                    class="see ma-1"
                                    icon
                                    small
                                    dark
                                    @click="
                                        $router.push({
                                            name: 'tours_detail',
                                            params: { id: item.id },
                                        })
                                    "
                                >
                                    <v-icon size="16">mdi-eye</v-icon>
                                </v-btn>
                            </template>

                            <template #[`item.steps`]="{ item }">
                                <span
                                    v-for="(step, index) in item.steps"
                                    :key="step.id"
                                    class="deliveries-list"
                                >
                                    <v-tooltip max-width="600px" top>
                                        <template #activator="{ on, attrs }">
                                            <v-avatar
                                                :class="
                                                    getStateColor(
                                                        step.step_state
                                                    )
                                                "
                                                class="deliveries"
                                                rounded
                                                size="30"
                                                v-bind="attrs"
                                                @click="
                                                    $router.push({
                                                        name: 'tours_detail',
                                                        params: { id: item.id },
                                                        query: {
                                                            position: index,
                                                        },
                                                    })
                                                "
                                                v-on="on"
                                            >
                                                {{
                                                    getSymbolFromState(
                                                        step.step_state
                                                    )
                                                }}
                                            </v-avatar>
                                        </template>
                                        <span>
                                            <div class="font-weight-bold">
                                                {{ step.customer.name }}
                                            </div>
                                            <div>
                                                {{
                                                    getSecondLineStepDetail(
                                                        step
                                                    )
                                                }}
                                            </div>
                                        </span>
                                    </v-tooltip>
                                </span>
                            </template>

                            <template #[`footer.prepend`]>
                                <div class="legende-datable">
                                    <span class="element in-progress">
                                        <span class="letter">C</span>
                                        {{ $t("tours.legende_progress") }}
                                    </span>
                                    <span class="element differed">
                                        <span class="letter">D</span>
                                        {{ $t("tours.legende_differed") }}
                                    </span>
                                    <span class="element non-blocking-anomaly">
                                        <span class="letter">N</span>
                                        {{
                                            $t(
                                                "tours.legende_non_blocking_anomaly"
                                            )
                                        }}
                                    </span>
                                    <span class="element blocking-anomaly">
                                        <span class="letter">B</span>
                                        {{
                                            $t("tours.legende_blocking_anomaly")
                                        }}
                                    </span>
                                    <span class="element delivered">
                                        <span class="letter">L</span>
                                        {{ $t("tours.legende_deliveries") }}
                                    </span>
                                </div>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-col>
</template>

<script>
import {
    LOADING_COMPLETED_STATE,
    LOADING_NON_BLOCKING_ANOMALY,
    STEP_BLOCKING_ANOMALY_STATE,
    STEP_COMPLETED_STATE,
    STEP_DELAYED_STATE,
    STEP_IN_PROGRESS_STATE,
    STEP_NON_BLOCKING_ANOMALY_STATE,
    TOUR_DELIVERED_STATE, TOUR_WAITING_STATE
} from "../../constants";
import step_states from "../../mixins/step_states";
import debounce from "tiny-debounce";
import Config from "../../config.singleton";

export default {
    name: "Tours",
    mixins: [step_states],
    data() {
        return {
            tours: [],
            sites: [],
            drivers: [],
            loading_states: [],
            tour_states: [],
            search: null,
            menu_date_picker: "",
            loading: false,
            totalTours: 0,
            default_filters: {
                driver_id: null,
                expected_date: null,
                tour_state_id: null,
                loading_state_id: null,
                site_id: null,
                search: null,
                per_page: null,
                page: null,
            },
            filters: {},
            headers: [
                {
                    text: this.$t("global.date"),
                    align: "start",
                    sortable: true,
                    value: "expected_date",
                    width: "5%",
                },
                {
                    text: this.$t("tours.designation"),
                    align: "start",
                    sortable: true,
                    value: "label",
                    width: "7%",
                },
                {
                    text: Config.driver_label ?? this.$tc('tours.driver', 1),
                    align: "start",
                    sortable: true,
                    value: "driver",
                    width: "12%",
                },
                {
                    text: this.$t("tours.loading"),
                    align: "center",
                    sortable: true,
                    value: "loading",
                    width: "7%",
                },
                {
                    text: this.$tc("tours.deliveries", 2),
                    align: "start",
                    sortable: true,
                    value: "steps",
                    width: "55%",
                },
                {
                    text: this.$t("tours.tour_status"),
                    align: "center",
                    sortable: false,
                    value: "tour_state",
                    width: "8%",
                },
                {
                    text: this.$t("global.actions"),
                    align: "center",
                    sortable: false,
                    value: "actions",
                    width: "5%",
                },
            ],
        };
    },
    computed: {
        driverLabel() {
            return Config.driver_label ?? this.$tc('tours.driver', 1)
        },
        dateFormatted() {
            const sortDate = this.filters?.expected_date;

            if (Array.isArray(sortDate)) sortDate.sort();

            const dateFormated = sortDate?.map((date) =>
                date.toDate()
            );

            if (Array.isArray(dateFormated)) return dateFormated.join(' ~ ')

            return dateFormated;
        },
    },
    watch: {
        search: debounce(function (val) {
            this.getTours();
        }, 500),
    },
    mounted() {
        this.filters = this.$root.getFilters("tours", this.default_filters);
        this.filters.expected_date =
            this.filters.expected_date ?? [new Date().toISOString().substring(0, 10)];

        if (!Array.isArray(this.filters.expected_date)) {
            this.filters.expected_date = [this.filters.expected_date];
        }

        this.filters.per_page = this.filters.per_page ?? 25;
        this.getTours();
        this.$api.drivers
            .all()
            .then(({data: drivers}) => (this.drivers = drivers.data));
        this.$api.loading_states
            .all()
            .then(
                ({data: loading_states}) =>
                    (this.loading_states = loading_states.data)
            );
        this.$api.tour_states
            .all()
            .then(
                ({data: tour_states}) => (this.tour_states = tour_states.data)
            );
        this.$api.sites
            .all()
            .then(({data: sites}) => (this.sites = sites.data));
    },
    methods: {
        getLoading(loading) {
            if (loading === LOADING_COMPLETED_STATE) {
                return "load";
            } else if (loading === LOADING_NON_BLOCKING_ANOMALY) {
                return "anomaly";
            } else {
                return "in-progress";
            }
        },
        getLoadingIcon(loading) {
            switch (loading) {
                case LOADING_COMPLETED_STATE:
                    return "check-bold";
                case LOADING_NON_BLOCKING_ANOMALY:
                    return "exclamation-thick";
                default:
                    return "timer-sand";
            }
        },
        getTourStatus(tour_status) {
            if (tour_status === TOUR_DELIVERED_STATE) {
                return "load";
            } else if (tour_status === TOUR_WAITING_STATE) {
                return "waiting";
            } else {
                return "in-progress";
            }
        },
        getTourStatusIcon(tour_status) {
            switch (tour_status) {
                case TOUR_DELIVERED_STATE:
                    return "check";
                case TOUR_WAITING_STATE:
                    return "timer-sand";
                default:
                    return "sync";
            }
        },
        getSymbolFromState({code: state = null}) {
            switch (state) {
                case STEP_COMPLETED_STATE:
                    return "L";
                case STEP_IN_PROGRESS_STATE:
                    return "C";
                case STEP_DELAYED_STATE:
                    return "D";
                case STEP_NON_BLOCKING_ANOMALY_STATE:
                    return "N";
                default:
                    return "B";
            }
        },
        reset() {
            this.search = null;
            delete this.filters.driver_id;
            delete this.filters.loading_state_id;
            delete this.filters.tour_state_id;
            delete this.filters.site_id;
            this.menu_date_picker = "";
            this.filters.expected_date = [new Date()
                .toISOString()
                .substring(0, 10)];
        },
        getSecondLineStepDetail(step) {
            if (
                [STEP_COMPLETED_STATE, STEP_BLOCKING_ANOMALY_STATE].includes(
                    step.step_state.code
                )
            ) {
                return this.$t("tooltips.no_missing_quantity");
            }
            if (STEP_NON_BLOCKING_ANOMALY_STATE === step.step_state.code) {
                return this.$t("tooltips.missing_quantity");
            }
            if (step.step_state.code === STEP_DELAYED_STATE) {
                return step.delayed_step?.comment;
            }
        },
        getTourTooltipDetail(item) {
            if (item.loading_state.code === LOADING_COMPLETED_STATE) {
                return this.$t("tooltips.no_missing_quantity");
            }
            if (item.loading_state.code === LOADING_NON_BLOCKING_ANOMALY) {
                return this.$t("tooltips.missing_quantity");
            }
        },
        getTours() {
            this.loading = true;

            const expected_date = this.filters.expected_date;

            this.$api.tours
                .all({
                    params: {
                        includes:
                            "tour.driver,tour.tour_state,tour.tour_model.tour_type,tour_model.model_number,model_number.site,tour.steps,step.step_state,tour.loading_states,step.customer,step.delayed_step",
                        expected_date: expected_date.sort(),
                        loading_state_id: this.filters.loading_state_id,
                        tour_state_id: this.filters.tour_state_id,
                        site_id: this.filters.site_id,
                        driver_id: this.filters.driver_id,
                        per_page: this.filters.per_page,
                        page: this.filters.page,
                        label_or_driver: this.search,
                    },
                })
                .then(({data: tours}) => {
                    this.tours = tours.data;
                    this.totalTours = tours.meta.total;
                })
                .finally(() => (this.loading = false));
        },
        filterTours() {
            this.filters.page = 1;
            this.$root.saveFilters("tours", this.filters);
            this.getTours();
        },
        pageChanged() {
            let filters = this.$root.getFilters("tours", this.default_filters);
            filters.page = this.filters.page;
            this.$root.saveFilters("tours", filters);
            this.getTours();
        },
        perPageChanged() {
            let filters = this.$root.getFilters("tours", this.default_filters);
            filters.per_page = this.filters.per_page;
            this.$root.saveFilters("tours", filters);
            this.getTours();
        },
    },
};
</script>
